export default "__VITE_ASSET__7FbHcvUw__"